import {RouteObject} from "react-router";
import {ErrorPage} from "@src/Layers/ErrorLayer/ErrorPage.tsx";
import {BackButtonViewPage} from "@src/CommonComponents/HeaderWithBackButton/HeaderWithBackButton.tsx";
import {CalendarPage} from "./CalendarPage.tsx";

export const calendarPageRoute: RouteObject = {
    path: "calendar",
    element: (
        <BackButtonViewPage title={"Schedule calendar"} backLink={"/check-in/"} showFilters={true}>
            <CalendarPage/>
        </BackButtonViewPage>
    ),
    errorElement: <ErrorPage header={false}/>
}
